import { Box, Heading, Text, Stack, VStack } from "@chakra-ui/layout";
import { Image, useToast } from "@chakra-ui/react";
import { useEffect, useState } from "react";

import { $ok } from "foundation-ts/commons";
import { Nullable } from "foundation-ts/types";

import { G1Button } from "@components/G1Button";
import { TemporaryAuthenticatedLayout, TemporaryChildProps } from "@components/layouts/TemporaryAuthenticatedLayout";
import { AsyncConfirmModal } from "@components/Modals/AsyncConfirmModal";
import { DefaultAsyncConfirmModalState } from "@components/Modals/ModalConstants";
import { config } from "@/config/config";
import { SessionSharedData } from "@containers/toBeSignedDocuments/ExternalSignView";
import { getTokenSessionStruct, unsubscribeDownloadSignedDocReminder } from "@services/session.service";
import { $g1Color, $g1IconURL } from "@/theme/G1Style";
import { defaultInfoToast } from "@utils/toast";

const UnsubscribeDownloadSignedDocumentsPage = () => {
    return (
        <TemporaryAuthenticatedLayout getData={async (token: string) => {
            const tokenSessionStruct = await getTokenSessionStruct(token) ;
            if (!$ok(tokenSessionStruct)) { return null ; }

            try {
                return { ...tokenSessionStruct!, token: token } ;
            } catch (e) {
                return null;
            }
        }}>
            <UnsubscribeView />
        </TemporaryAuthenticatedLayout>
    ) ;
}

export default UnsubscribeDownloadSignedDocumentsPage ;


const UnsubscribeView = ({ sharedData } : TemporaryChildProps) => {
    const [confirmModal, setConfirmModal] = useState(DefaultAsyncConfirmModalState);
    const [sessionSharedData, setSessionSharedData] = useState<Nullable<SessionSharedData>>(null);
    const [disabled, setDisabled] = useState(false);
    const toast = useToast();

    useEffect(() => {
        if ($ok(sharedData)) {
            setSessionSharedData(sharedData as SessionSharedData);
        }
    }, [sharedData]);

    return (
        <>
            <Box margin="auto">
                <Box color={$g1Color('connection.logo.write')} bg={$g1Color('connection.logo.bg')} py="8" px="8" maxW="md" mx="auto" rounded={{ base: "0", md: "2xl" }}>
                    <VStack spacing="4" align="stretch">
                        <Stack direction="row" alignItems="center" spacing="2">
                            <Image src={$g1IconURL('connection.logo.iconurl')} alt="Application logo" boxSize="72px" />
                            <Heading as="h1" textAlign="center" size="lg" fontWeight="bold">
                                {config.app.title}
                            </Heading>
                        </Stack>
                        <Text textAlign="center" fontWeight="bold" fontSize="20px">
                            Désinscription aux relances de téléchargement de documents signés
                        </Text>
                        <Text>Etes-vous sûr d'avoir récupéré les documents signés de la session '{sessionSharedData?.sessionTitle}' ?</Text>
                        <Text>Si oui, vous pouvez cliquer sur "Me désabonner".</Text>
                        <G1Button component="form" variant="ok" title="Me désabonner" disabled={disabled} onClick={() => setConfirmModal({
                            title: "Confirmation de désabonnement",
                            message: "Etes-vous sûr de vouloir vous désabonner ?",
                            onAccept: async () => {
                                await unsubscribeDownloadSignedDocReminder(sessionSharedData?.sessionId, sessionSharedData?.token, sessionSharedData?.signatureId);
                                toast(defaultInfoToast("Votre désinscription a été pris en compte"));
                                setDisabled(true);
                                setConfirmModal(DefaultAsyncConfirmModalState);
                            },
                            onClose: async () => { setConfirmModal(DefaultAsyncConfirmModalState); }
                        })} />
                    </VStack>
                </Box>
            </Box>
            <AsyncConfirmModal title={confirmModal.title} message={confirmModal.message} onAccept={confirmModal.onAccept} onClose={confirmModal.onClose} />
        </>
    );
};




